module.exports = __webpack_public_path__ + "assets/7b7a8575cce927fbfece914110828999.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/sounds/buttons/lines/line_2.mp3
 ** module id = 52
 ** module chunks = 0
 **/